export default __webpack_public_path__ + "static/media/warningIcon.330aa37b.svg";